import Skeleton from "@mui/material/Skeleton";
import Typography from "@mui/material/Typography";

import { useTriggerById } from "@/shared/domain/triggers/hooks";
import { RobotoNotFoundException } from "@/shared/http";

import { TriggerNameLink } from "./TriggerNameLink";

interface TriggerLinkProps {
  triggerId: string;
}

/**
 * Resolves a trigger id to a name link through GET /v1/triggers/id/<id>,
 * which serves every trigger, event-driven or schedule-fired.
 */
export function TriggerLink({ triggerId }: TriggerLinkProps) {
  const triggerQuery = useTriggerById(triggerId);

  if (triggerQuery.isPending) {
    return (
      <Typography variant="body2">
        <Skeleton variant="text" width="200px" />
      </Typography>
    );
  }

  if (triggerQuery.data) {
    return <TriggerNameLink triggerName={triggerQuery.data.name} />;
  }

  if (triggerQuery.error instanceof RobotoNotFoundException) {
    return (
      <Typography
        color="GrayText"
        sx={{ textDecorationLine: "line-through" }}
        title="This trigger no longer exists"
        variant="body2"
      >
        {triggerId}
      </Typography>
    );
  }

  return (
    <Typography
      color="error"
      title="Failed to load link to trigger"
      variant="body2"
    >
      {triggerId}
    </Typography>
  );
}
